import {API_ACTION, API_DEPARTMENT, API_DEPARTMENT_ALL} from '../../const/Api';
import {RestApiMethod} from '../../const/dataEnum';
import {callAPI} from './callApi';

const fetchDepartments = async (isGetAllDept = false) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: isGetAllDept ? API_DEPARTMENT_ALL : API_DEPARTMENT,
    });
    return res.data;
  } catch (error) {
    console.error('departmentApi fetchDepartments error:', error.message);
    return null;
  }
};

const getAllDepartment = async (userAuthRoleId) => {
  if (!userAuthRoleId) {
    console.error('getAllDepartment failed: userAuthRoleId not valid. Call API cancel.');
    return null; 
  }
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: `${API_DEPARTMENT_ALL}/${userAuthRoleId}`,
    });
    return res.data.data;
  } catch (error) {
    console.error('getAllDepartment Error:', error.message);
    return null;
  }
};

const getDepartments = async () => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_DEPARTMENT,
    });
    return res.data?.data || [];
  } catch (error) {
    console.error('departmentApi getDepartments error:', error.message);
    return null;
  }
};

const updateDepartment = async (department) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.POST,
      url: API_DEPARTMENT + API_ACTION.UPDATE,
      data: department,
    });
    return res.data;
  } catch (error) {
    console.error('departmentApi updateDepartment Error:', error.message);
    return null;
  }
};

const departmentApi = {
  getAllDepartment,
  getDepartments,
  updateDepartment,
  fetchDepartments,
};

export default departmentApi;
